import * as types from 'modules/interventions/actionTypes';

import { createReducer } from 'utils/ReduxUtils';

/** @typedef {boolean} State */

/** @type State */
const initialState = false;

/**
 * @returns {State}
 */
const open = () => true;

/**
 * @returns {State}
 */
const close = () => false;

export default createReducer(initialState, {
  [types.OPEN_APPROVE_MANUALLY_MODAL]: open,
  [types.APPROVE_MANUALLY_SUCCESS]: close,
  [types.CLOSE_APPROVE_MANUALLY_MODAL]: close,
});
